import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Offers from './pages/Offers';
import OfferEditor from './pages/OfferEditor';
import Services from './pages/Services';
import SettingsPage from './pages/Settings';
import Users from './pages/Users';
import { useI18n } from './lib/i18n';

export default function App() {
  const { user, isLoading, isAdmin } = useAuth();
  const { t } = useI18n();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-gray-500">
        {t('common.loading')}
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Offers />} />
        <Route path="/offers/:id" element={<OfferEditor />} />
        <Route path="/login" element={<Navigate to="/" replace />} />
        {isAdmin && <Route path="/services" element={<Services />} />}
        {isAdmin && <Route path="/settings" element={<SettingsPage />} />}
        {isAdmin && <Route path="/users" element={<Users />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
